import React, { useState, Fragment } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { Tooltip } from 'antd';
import { get, join, map, size } from 'lodash';
import { withNavigation, withFirebase } from '../../../../hoc';
import {
    Title,
    Text,
    Row,
    Column,
    Divider,
    AppIcon,
    FlexContainer,
    Icon,
    ConditionalRender,
    Truncate,
    OrderShippingEstimate
} from '../../../../components/common';
import OrderAuditManagement, { OrderAuditManagementConsumer } from '../../../../components/firebase/OrderAuditManagement';
import OrderEventsFeed from '../../../../components/firebase/OrderEventsFeed';
import OrderStatusAudit from './OrderStatusAudit';
import { timeDiffIn, formatTime, cleanOrderId, capitalizeNames } from '../../../../utils/misc';
import useInterval from '../../../../components/hooks/useInterval';
import { RED } from '../../../../utils/colors';
import { getIconTypeClient } from '../auditOrderDrawer/components/auditOrder/variants/headerInfoShared';
import AuditOrderCardContentLegacy from './variants/AuditOrderCardContentLegacy';
import { useAuditNewDesignFlag } from '../../hooks/useAuditNewDesignFlag';

const StateCardAuditContainer = styled.div`
    min-width: 90px;
    width: 120px;
    max-width: 150px;
    min-height: 52px;
    border-radius: 16px;
    padding: 8px;
    background-color: rgba(164, 199, 53, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    `;

const HeaderCardContainer = styled.div`
margin-bottom: 16px;
`
const OrderBodyRow = styled(Row)`
    min-height: 30px;
`;

const CardText = styled(Text)`
    font-size: ${({ size = 12 }) => size}px;
    color: ${({ color = '#333333' }) => color};
    text-align: center;
`;

const CardTitle = styled(Title)`
    font-size: ${({ size = 12 }) => size}px;
    color: ${({ color = '#333333' }) => color};
    text-align: right;
`;
const CardTitleLeft = styled(Title)`
    font-size: ${({ size = 12 }) => size}px;
    color: ${({ color = '#333333' }) => color};
    text-align: left;
`;

const OrderBody = ({ data, text, createdAt, deliveryDate }) => {
    const [minutes, updateMinutes] = useState(0);

    useInterval(() => {
        updateMinutes(minutes + 1);
    }, 60000);

    return (
        <OrderStatusAudit orderId={get(data, 'id')}>
            {({ ts }) => {
                const timeInAudit = timeDiffIn(ts, 'minutes', moment(createdAt).add(minutes, 'minutes'));
                const arrayRules = get(data, 'assignInfo.auditInfo.smartrules', [])
                const newRules = arrayRules?.length > 0 ? true : false
                const oldRules = map(get(data, 'assignInfo.auditInfo.rules', []), (rule, index) => (
                    <Fragment key={index}>
                        <Text text={`order_audit.rule.${rule}`} strong />
                        {(index + 1 < (size(get(data, 'assignInfo.auditInfo.rules', [])))) && <span> - </span>}
                    </Fragment>
                ))
                return (<>
                    <HeaderCardContainer>
                        <Row gap={5} flex={1} align='center'>
                            <Column>
                                <Row>
                                    <a href={`/orders/${get(data, 'id')}`}>
                                        <Text
                                            text={<>
                                                {cleanOrderId(get(data, 'id'))}
                                            </>}
                                            size={14}
                                            strong
                                            textDecoration='underline'
                                            color='#4cb358'
                                        />
                                    </a>
                                </Row>
                                <Row gap={4}>
                                    <CardText size={11} text='Fecha de entrega:' />
                                    <Text strong size={11} text={deliveryDate} weight={700} />
                                </Row>
                                <Row gap={4} >
                                    <CardText size={11} text='Hora entrega:' />
                                    <Text weight={700} text={text} strong size={11} />
                                </Row>
                            </Column>
                            <StateCardAuditContainer>
                                <Row justify="space-between">
                                    <CardText size={10} strong text={timeInAudit > 0 ? 'En auditoría' : 'Para auditar'} />
                                    {renderAuditStatus(get(data, 'id'))}
                                </Row>
                                <Text text={formatTime(timeInAudit)} size={13} color={timeInAudit >= 5 ? '#db5959' : '#4cb358'} strong />
                            </StateCardAuditContainer>
                        </Row>
                    </HeaderCardContainer>
                    <OrderBodyRow>
                        <Column align='flex-start' justify='center' >
                            <CardText text='Picker' size={14} />
                        </Column>
                        <Column align='flex-end' justify='center' flex={1.5}>
                            <Text
                                size={14}
                                strong
                                align='right'
                                text={<Truncate width={150}>
                                    {capitalizeNames(join([get(data, 'assignInfo.picker.firstName'), get(data, 'assignInfo.picker.lastName')], ' '))}
                                </Truncate>}
                            />
                        </Column>
                    </OrderBodyRow>
                    <Divider />
                    <OrderBodyRow>
                        <Column align='flex-start' justify='center'>
                            <CardText text='Productos aprobados' />
                        </Column>
                        <Column align='flex-end' justify='center' flex={0.2}>
                            <CardTitle>{get(data, 'assignInfo.auditInfo.passedCount')}</CardTitle>
                        </Column>
                    </OrderBodyRow>
                    <Divider />
                    <OrderBodyRow>
                        <Column align='flex-start' justify='center'>
                            <CardText text='Productos en validación' />
                        </Column>
                        <Column align='flex-end' justify='center' flex={0.2}>
                            <CardTitle>{get(data, 'assignInfo.auditInfo.failedCount')}</CardTitle>
                        </Column>
                    </OrderBodyRow>
                    <Divider />
                    <OrderBodyRow>
                        <Column align='flex-start' justify='center'>
                            <CardText text='Total de productos' />
                        </Column>
                        <Column align='flex-end' justify='center' flex={0.2}>
                            <CardTitle>{Number(get(data, 'assignInfo.auditInfo.failedCount')) + Number(get(data, 'assignInfo.auditInfo.passedCount'))}</CardTitle>
                        </Column>
                    </OrderBodyRow>
                    <Divider />
                    <OrderBodyRow>
                        <Column align='flex-start' justify='center'>
                            <CardText text='Tipo de cliente' />
                        </Column>
                        <Column align='flex-end' justify='center' flex={0.2}>


                            {console.log('data', data)}
                            {
                                (get(data, 'customer.isUltraVIP') || get(data, 'customer.isVIP') || get(data, 'customer.isCencoPrime')) ?
                                    getIconTypeClient(data, 20, 20)
                                    :
                                    <CardTitle>Regular</CardTitle>
                            }
                        </Column>
                    </OrderBodyRow>
                    <Divider />
                    <OrderBodyRow>
                        <Column align='flex-start' justify='center'>
                            <CardText text='Regla auditoría' />
                            <CardTitleLeft >
                                {newRules ?
                                    <OrderBodyRow>
                                        {arrayRules?.length > 0 && [...new Set(arrayRules.map(rule => rule.reason))].map((reason, index) => (
                                            <Fragment key={index}>
                                                <Text text={reason} strong />
                                                {(index + 1 < [...new Set(arrayRules.map(rule => rule.reason))].length) && <span> - </span>}
                                            </Fragment>
                                        ))}
                                    </OrderBodyRow>
                                    :
                                    oldRules
                                }
                            </CardTitleLeft>
                        </Column>
                    </OrderBodyRow>
                    <Divider />
                </>);
            }}
        </OrderStatusAudit>
    );
};

const renderAuditStatus = (orderId) => (
    <OrderAuditManagementConsumer orderId={orderId}>
        {({ taken, userName, loading }) => (
            <ConditionalRender condition={taken && !loading}>
                <FlexContainer justify='flex-end'>
                    <Tooltip placement='top' title={`Tomada por ${userName}`}>
                        <AppIcon name='closed-hand' size={16} color='#f39c12' />
                    </Tooltip>
                </FlexContainer>
            </ConditionalRender>
        )}
    </OrderAuditManagementConsumer>
);

const AuditOrderCardContentNew = ({ data, bipickingInfo }) => {
    const orderId = get(data, 'id');
    const isExpress = get(data, 'logisticsInfo.selectedSla', null) === 'Despacho Express';

    return (
        <OrderEventsFeed orderId={orderId}>
            <OrderAuditManagement orderId={orderId}>
                <OrderShippingEstimate {...data}>
                    {({ diffInMinutes, deliveryDate, deliveryTime, deliveryTimeHour }) => {
                        return (<div style={{ display: 'flex', flexDirection: 'column', flex: 1 }} >
                            <Row>
                                <Row gap={5} flex={4} align='center'>
                                    {bipickingInfo?.isBipicking && (
                                        <Icon
                                            name={bipickingInfo.iconName}
                                            size={16}
                                            color={bipickingInfo.iconColor}
                                        />
                                    )}
                                </Row>
                                <Row gap={5} flex={5} align='center'>
                                    {bipickingInfo?.showRelatedLabel && (<>
                                        <Icon
                                            name='bipicking-b'
                                            size={16}
                                            color={RED}
                                        />
                                        <a href={`/orders/${bipickingInfo.partnerId}`}>
                                            <Text
                                                text='Order relacionada'
                                                size={12}
                                                style={{ textDecoration: 'underline' }}
                                            />
                                        </a>
                                    </>)}
                                </Row>
                            </Row>
                            {diffInMinutes < -45 && <Divider bottom='-15' />}
                            <OrderBody data={data} text={isExpress ? deliveryTimeHour : deliveryTime} deliveryDate={deliveryDate} />
                        </div>);
                    }}
                </OrderShippingEstimate>
            </OrderAuditManagement>
        </OrderEventsFeed>
    );
};

const AuditOrderCardContentNewWithNavigation = withNavigation(AuditOrderCardContentNew);

const AuditOrderCardContent = ({ firebase, ...props }) => {
    const storeId = get(props.data, 'salesChannel.id');
    const isNewDesignEnabled = useAuditNewDesignFlag(firebase, storeId);

    return isNewDesignEnabled
        ? <AuditOrderCardContentNewWithNavigation {...props} />
        : <AuditOrderCardContentLegacy {...props} />;
};

export default withFirebase(AuditOrderCardContent);